import { useEffect } from "react";

/**
 * Manages document head tags for SEO: title, meta description, canonical,
 * open graph and JSON-LD schema.
 */
export function useSEO({ title, description, canonical, image, noindex, schema }) {
    useEffect(() => {
        if (title) document.title = title;

        const upsert = (selector, create) => {
            let el = document.head.querySelector(selector);
            if (!el) {
                el = create();
                document.head.appendChild(el);
            }
            return el;
        };

        if (description) {
            const el = upsert('meta[name="description"]', () => {
                const m = document.createElement("meta"); m.setAttribute("name", "description"); return m;
            });
            el.setAttribute("content", description);
        }

        const url = canonical || window.location.href;
        const canon = upsert('link[rel="canonical"]', () => {
            const l = document.createElement("link"); l.setAttribute("rel", "canonical"); return l;
        });
        canon.setAttribute("href", url);

        const robots = upsert('meta[name="robots"]', () => {
            const m = document.createElement("meta"); m.setAttribute("name", "robots"); return m;
        });
        robots.setAttribute("content", noindex ? "noindex,nofollow" : "index,follow");

        const ogTitle = upsert('meta[property="og:title"]', () => {
            const m = document.createElement("meta"); m.setAttribute("property", "og:title"); return m;
        });
        ogTitle.setAttribute("content", title || "Venuely");

        const ogDesc = upsert('meta[property="og:description"]', () => {
            const m = document.createElement("meta"); m.setAttribute("property", "og:description"); return m;
        });
        ogDesc.setAttribute("content", description || "");

        const ogUrl = upsert('meta[property="og:url"]', () => {
            const m = document.createElement("meta"); m.setAttribute("property", "og:url"); return m;
        });
        ogUrl.setAttribute("content", url);

        const ogType = upsert('meta[property="og:type"]', () => {
            const m = document.createElement("meta"); m.setAttribute("property", "og:type"); return m;
        });
        ogType.setAttribute("content", "website");

        if (image) {
            const ogImg = upsert('meta[property="og:image"]', () => {
                const m = document.createElement("meta"); m.setAttribute("property", "og:image"); return m;
            });
            ogImg.setAttribute("content", image);
        }

        // JSON-LD Schema
        document.querySelectorAll('script[data-schema="venuely"]').forEach((n) => n.remove());
        if (schema) {
            const arr = Array.isArray(schema) ? schema : [schema];
            arr.forEach((s) => {
                const script = document.createElement("script");
                script.type = "application/ld+json";
                script.setAttribute("data-schema", "venuely");
                script.text = JSON.stringify(s);
                document.head.appendChild(script);
            });
        }
    }, [title, description, canonical, image, noindex, JSON.stringify(schema || {})]);
}
